<template>
  <div class="card">
    <div v-if=img class="card-image">
      <figure class="image" :class="imageClass">
        <ClickableImage :src="img" :alt="imgAlt" :ratio="imageClass" />
      </figure>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p v-if=title class="title is-4">{{title}}</p>
          <p v-if=subtitle class="subtitle is-6">{{subtitle}}</p>
        </div>
        <div class="media-right">
          <figure v-if="warningBorder" class="image is-24x24 is-inline-block mechanic-badge">
            <img :src="require('../assets/badges/warning-border.png')" alt="Warning Border" title="Warning Border">
          </figure>
          <figure v-if="blockable" class="image is-24x24 is-inline-block mechanic-badge">
            <a href="https://wiki.guildwars2.com/wiki/Block">
              <img :src="require('../assets/badges/block.png')" alt="Blockable" title="Blockable">
            </a>
          </figure>
          <figure v-if="unblockable" class="image is-24x24 is-inline-block mechanic-badge">
            <a href="https://wiki.guildwars2.com/wiki/Unblockable">
              <img :src="require('../assets/badges/unblockable.png')" alt="Unblockable" title="Unblockable">
            </a>
          </figure>
          <figure v-if="evadable" class="image is-24x24 is-inline-block mechanic-badge">
            <a href="https://wiki.guildwars2.com/wiki/Evade">
              <img :src="require('../assets/badges/evade.png')" alt="Evadable" title="Evadable">
            </a>
          </figure>
        </div>
      </div>
      <DefianceBar class="breakbar" v-if="breakbar !== null" :size="breakbar" />
      <div class="content">
        <slot></slot>
        <!-- TODO: Make sure this is on the bottom of the card -->
        <b-collapse v-if="hasDetailSlot" :open="false" position="is-bottom" aria-id="contentIdForA11y1">
          <template #trigger="props">
            <a aria-controls="contentIdForA11y1">
              <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
              {{ !props.open ? 'More details' : 'Fewer details' }}
            </a>
          </template>
          <slot name="details"></slot>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import DefianceBar from "@/submodules/raid-guides/components/DefianceBar";
import ClickableImage from "@/submodules/raid-guides/components/ClickableImage";

export default {
  name: "MechanicCard",
  components: {ClickableImage, DefianceBar},
  //props: ['title', 'subtitle', 'img', 'imgAlt'],
  props: {
    'title': String,
    'subtitle': String,
    'img': {},
    'imgAlt': String,
    'imageClass': {
      type: String,
      default: 'is-1by1'
    },
    'blockable': {
      type: Boolean,
      default: false
    },
    'unblockable': {
      type: Boolean,
      default: false
    },
    'evadable': {
      type: Boolean,
      default: false
    },
    'warningBorder': {
      type: Boolean,
      default: false
    },
    'breakbar': {
      type: String,
      default: null
    }
  },
  computed: {
    hasDetailSlot() {
      return !!this.$slots.details;
    },
  },
}
</script>

<style scoped>
.mechanic-badge {
  margin-right: 3px;
}
.breakbar {
  margin-top: -20px;
  margin-bottom: 15px;
}

</style>